import messages from '../../../locale/messages';
import { inputDescLimit, inputTextLimit } from '../../../helpers/FieldRestriction';

const validate = values => {
    const errors = {};

    if (!values.name) {
        errors.name = messages.required;
    } else if (values.name.trim() == "") {
        errors.name = messages.required;
    } else if (values.name.length > inputTextLimit) {
        errors.name = messages.inputTextLimitError;
    }

    if (!values.description) {
        errors.description = messages.required;
    } else if (values.description.trim() == "") {
        errors.description = messages.required;
    } else if (values.description.length > inputDescLimit) {
        errors.description = messages.inputDescLimitError;
    }

    if (!values.categoryId) {
        errors.categoryId = messages.required;
    }

    return errors;
};

export default validate